import { render, staticRenderFns } from "./signers.vue?vue&type=template&id=0150fb28&scoped=true"
import script from "./signers.vue?vue&type=script&lang=js"
export * from "./signers.vue?vue&type=script&lang=js"
import style0 from "./signers.vue?vue&type=style&index=0&id=0150fb28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0150fb28",
  null
  
)

export default component.exports